import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Swipeable } from 'vue-swipeable';
import '@/assets/styles/global.scss';

import { vHorizontalScroll } from '@/libraries/vertical-scroll-converter';
import { vPreventBrowserGestures } from '@/libraries/prevent-browser-gestures';
import { initSentry, sentryPiniaPlugin } from '@/sentry';
import App from './App.vue';
import router from './router';

const app = createApp(App);
app.directive('swipeable', Swipeable);
app.directive('horizontal-scroll', vHorizontalScroll);
app.directive('prevent-browser-gestures', vPreventBrowserGestures);

const pinia = createPinia();
pinia.use(sentryPiniaPlugin());
app.use(pinia);
app.use(router);

initSentry(app, router);

app.mount('#app');
